module.exports = new __parcel__URL__("storage.1fbb6bc1.svg").toString();